import * as React from 'react'

type Props = {
  letter: string
  onClickLetter: (letter: string) => void
  correctLetters: Set<string>
  presentLetters: Set<string>
  wrongLetters: Set<string>
}

const KeyboardLetter = ({
  letter,
  onClickLetter,
  correctLetters,
  presentLetters,
  wrongLetters,
}: Props) => {
  const handleClick = () => {
    onClickLetter(letter)
  }

  let bgColour = 'bg-gray-500 hover:border-gray-400'
  if (correctLetters.has(letter)) bgColour = 'bg-green-500 hover:border-green-200'
  else if (presentLetters.has(letter)) bgColour = 'bg-yellow-600 hover:border-yellow-300'
  else if (wrongLetters.has(letter)) bgColour = 'bg-gray-800'

  return (
    <div
      onClick={handleClick}
      className={`flex justify-around items-center mx-0.5 mt-1 h-12 w-8 cursor-pointer
        border border-solid border-gray-700 shadow-zinc-500 shadow-sm ${bgColour}
        text-2xl font-bold`}
    >
      {letter}
    </div>
  )
}

export default KeyboardLetter
